import { includes, map } from "lodash";
import { useCurrentUserLocale } from "@linkfluence/core/user/use-cases";
import { useContextualFocuses } from "@radarly/core/context/use-cases";
import { tr } from "@radarly/i18n";
import { WizardTemplate } from "@radarly/models/insight-pages/wizard/model";
import { WizardPropertiesConfiguration } from "@radarly/models/insight-pages/wizard/model/configuration";

export function useWizardGlobalProperties({
  template,
  wizardConfiguration,
  globalFields,
}: {
  template: WizardTemplate;
  wizardConfiguration: WizardPropertiesConfiguration;
  globalFields: string[];
}) {
  const locale = useCurrentUserLocale();
  const contextualFocuses = useContextualFocuses();

  return {
    ...wizardConfiguration,
    size: "m" as const,
    hasPeriodSelector: true,
    hasQuerySelector: includes(globalFields, "query"),
    hasQueriesSelector: includes(globalFields, "queries"),
    form: {
      title: {
        rules: {
          required: true,
        },
        label: tr(
          locale,
          "INSIGHT_PAGE_TEMPLATE_" + template.id + "::CONFIGURATION_TITLE_LABEL"
        ),
        placeholder: tr(
          locale,
          "INSIGHT_PAGE_TEMPLATE_" +
            template.id +
            "::CONFIGURATION_TITLE_PLACEHOLDER"
        ),
      },
      query: {
        title: tr(locale, "INSIGHT_PAGE_TEMPLATE_::CONFIGURATION_QUERIES"),
        rules: {
          required: true,
        },
        label: tr(
          locale,
          "INSIGHT_PAGE_TEMPLATE_" + template.id + "::CONFIGURATION_QUERY_LABEL"
        ),
        placeholder: tr(
          locale,
          "INSIGHT_PAGE_TEMPLATE_" +
            template.id +
            "::CONFIGURATION_QUERY_PLACEHOLDER"
        ),
        options: map(contextualFocuses, (query) => ({
          label: query.label,
          value: query.id,
        })),
      },
      queries: {
        rules: {
          required: true,
        },
        label: tr(
          locale,
          "INSIGHT_PAGE_TEMPLATE_" +
            template.id +
            "::CONFIGURATION_QUERIES_LABEL"
        ),
        placeholder: tr(
          locale,
          "INSIGHT_PAGE_TEMPLATE_" +
            template.id +
            "::CONFIGURATION_QUERIES_PLACEHOLDER"
        ),
        options: map(contextualFocuses, (query) => ({
          label: query.label,
          value: query.id,
        })),
      },
      period: {
        rules: {
          required: true,
        },
        label: tr(
          locale,
          "INSIGHT_PAGE_TEMPLATE_" +
            template.id +
            "::CONFIGURATION_PERIOD_LABEL"
        ),
        placeholder: tr(
          locale,
          "INSIGHT_PAGE_TEMPLATE_" +
            template.id +
            "::CONFIGURATION_PERIOD_PLACEHOLDER"
        ),
      },
    },
  };
}
